import React from 'react';
import {
  Table as MuiTable,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Box,
  styled,
  Pagination,
} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  '&:hover': {
    backgroundColor: theme.palette.action.selected,
  },
}));

const Table = ({
  dataArray,
  variantNameMap,
  openMenuIndex,
  menuPosition,
  toggleMenu,
  openEditModal,
  handleDeleteClick,
  menuRef,
  EditMenu,
  DeleteMenu,
  page,
  pageSize,
  totalCount,
  onPageChange,
  openViewModal, // added new prop
}) => {
  const totalPages = Math.ceil(totalCount / pageSize);

  const handlePageChange = (event, value) => {
    onPageChange(value);
  };

  return (
    <Box p={3}>
      <TableContainer component={Paper} elevation={3} sx={{ borderRadius: 2 }}>
        <MuiTable sx={{ minWidth: 650 }} aria-label="enhanced table">
          <TableHead>
            <TableRow sx={{ backgroundColor: (theme) => theme.palette.primary.main }}>
              <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Id</TableCell>
              <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Event Name</TableCell>
              <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Product Id</TableCell>
              <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Product Variant Id</TableCell>
              <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Product Type</TableCell>
              <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Updated At</TableCell>
              <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Created At</TableCell>
              <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {dataArray.map((item, idx) => (
              <StyledTableRow key={item.id || idx}>
                <TableCell>{item.id}</TableCell>
                <TableCell>
                  {item.eventName}
                  {item.productVariantId && variantNameMap && variantNameMap[item.productVariantId] ? (
                    <> - {variantNameMap[item.productVariantId]}</>
                  ) : null}
                </TableCell>
                <TableCell>{item.productId}</TableCell>
                <TableCell>{item.productVariantId}</TableCell>
                <TableCell>{item.product_type}</TableCell>
                <TableCell>
                  {item.updatedAt ? new Date(item.updatedAt).toLocaleString() : ''}
                </TableCell>
                <TableCell>
                  {item.createdAt ? new Date(item.createdAt).toLocaleString() : ''}
                </TableCell>
                <TableCell sx={{ position: 'relative', textAlign: 'center' }}>
                  <IconButton
                    aria-label="actions"
                    onClick={(e) => toggleMenu(idx, e)}
                    sx={{
                      width: 36,
                      height: 36,
                      borderRadius: '50%',
                      backgroundColor: 'rgba(255, 255, 255, 0.6)',
                      backdropFilter: 'blur(6px)',
                      WebkitBackdropFilter: 'blur(6px)',
                      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.2)',
                      '&:hover': {
                        backgroundColor: 'rgba(255, 255, 255, 0.8)',
                      },
                    }}
                  >
                    <MoreVertIcon sx={{ color: '#555' }} />
                  </IconButton>
                  {openMenuIndex === idx && (
                    <Box
                      ref={menuRef}
                      sx={{
                        position: 'fixed',
                        top: menuPosition.top,
                        left: menuPosition.left,
                        borderRadius: 1,
                        backgroundColor: 'background.paper',
                        boxShadow: 3,
                        zIndex: 999,
                        p: 1,
                        display: 'flex',
                        alignItems: 'center',
                        cursor: 'pointer',
                        flexDirection: 'row',
                        gap: 1,
                        border: '1px solid',
                        borderColor: 'divider',
                      }}
                    >
                      <span
                        style={{
                          display: 'inline-flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          borderRadius: '50%',
                          backgroundColor: '#dbeafe',
                          padding: '6px',
                          cursor: 'pointer',
                          marginLeft: '3px',
                          marginRight: '5px',
                          boxShadow: '0 2px 6px rgba(59, 130, 246, 0.3)',
                          transition: 'background-color 0.3s ease',
                        }}
                        title="View"
                        onClick={() => openViewModal(item.id)} // Changed onClick to call openViewModal with the item
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = '#bfdbfe';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = '#dbeafe';
                        }}
                      >
                        <RemoveRedEyeIcon fontSize="small" sx={{ color: '#1d4ed8' }} />
                      </span>
                      <EditMenu onEditClick={() => openEditModal(item)} />
                      <DeleteMenu onDeleteClick={(e) => handleDeleteClick(item, e)} />
                    </Box>
                  )}
                </TableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </MuiTable>
      </TableContainer>
      <Box display="flex" alignItems="center" justifyContent="center" mt={2} gap={0}>
        <Pagination
          count={totalPages}
          page={page}
          onChange={handlePageChange}
          color="primary"
        />
      </Box>
    </Box>
  );
};

export default Table;